import React from 'react';

import { Button, Col, Modal, Row } from 'react-bootstrap';

export const DeleteModal = ({
  title,
  message,
  onDelete,
  onHide,
  show,
  loading,
}) => {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontWeight: 400 }}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{message}</p>
      </Modal.Body>
      <Modal.Footer>
        <Row>
          <Col sm={6}>
            <Button block disabled={loading} onClick={onHide}>
              Cancel
            </Button>
          </Col>
          <Col sm={6}>
            <Button
              block
              bsStyle="primary"
              disabled={loading}
              onClick={onDelete}
            >
              Delete
            </Button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
};
